module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department03-96599883ae8dd0c7374bae6be6bf1172.jpg";